import { render, staticRenderFns } from "./customersth-add-or-update.vue?vue&type=template&id=c3c8ccd0&"
import script from "./customersth-add-or-update.vue?vue&type=script&lang=js&"
export * from "./customersth-add-or-update.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports